<template>
  <div class="page-container">
    <h1 class="page-title">{{ t('pages.company.honors.title') }}</h1>
    <p class="page-subtitle">{{ t('pages.company.honors.subtitle') }}</p>
    
    <!-- 荣誉资质概述 -->
    <!-- <div class="honors-description">
      <p>{{ t('pages.company.honors.content') }}</p>
    </div> -->

    <!-- 荣誉资质展示区 -->
   <div class="partner-grid-container">
      <!-- 合作伙伴网格 - 静态展示 -->
      <div  class="partner-grid">
        <div class="partner-card" v-for="(honor, index) in honorsList" :key="index" @dblclick="showBigImage(honor.image)">
          <div class="image-container">
                     <img :src="honor.image" :alt="honor.title">

          </div>
          <div class="partner-info">
            <div class="partner-name">{{ honor.title }}</div>
          
          </div>
        </div>
      </div>
    </div>

    <!-- 大图显示层 -->
    <div v-if="bigImageVisible" class="big-image-overlay" @click="hideBigImage">
      <img :src="currentBigImageUrl" alt="Enlarged image" class="enlarged-image" @click.stop />
    </div>
  </div>
   
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
// 导入模块
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';
import { useLangStore } from '../../../pinia/stores/lang';

const { t } = useI18n();
const langStore = useLangStore();

// 大图显示相关
const bigImageVisible = ref(false);
const currentBigImageUrl = ref('');

const showBigImage = (imageUrl: string) => {
  currentBigImageUrl.value = imageUrl;
  bigImageVisible.value = true;
};

const hideBigImage = () => {
  bigImageVisible.value = false;
  currentBigImageUrl.value = '';
};

// 根据当前语言选择对应的翻译数据
const translationData = computed(() => {
  console.log('当前语言:', langStore.currentLang);
  return langStore.currentLang.startsWith('zh') ? zhData : enData;
});

// 获取荣誉资质数据
const honorsList = computed(() => {
  const data = translationData.value.pages.company.honors.list;
  console.log('荣誉资质数据:', data);
  return data as {
    title: string;
    image: string;
  }[];
});
</script>


<style scoped lang="scss">
// 页面特定样式
.page-container {
  padding: 0px 30px 40px 80px;
  
  @media screen and (max-width: 768px) {
    padding: 0px 15px 20px 15px;
  }
}

.page-subtitle {
  text-align: center;
  margin: -20px auto 30px;
  color: #666;
  font-size: 16px;
  max-width: 800px;
}

.honors-description {
  margin: 0 auto 40px;
  max-width: 1000px;
  text-align: justify;
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  padding: 0 20px;
}

.honors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 25px;
}

.honor-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  }
  
  .image-container {
    height: 160px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f9f9;
    
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  
  .honor-info {
    padding: 15px;
    
    .honor-title {
      font-size: 15px;
      font-weight: 500;
      color: #333;
      margin-bottom: 5px;
      text-align: center;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      height: 40px;
    }
  }
}

.page-container {
  padding-bottom: 60px;
}

.page-subtitle {
  text-align: center;
  margin: -20px auto 30px;
  color: #666;
  font-size: 16px;
  max-width: 800px;
}

.carousel-container {
  height: 70vh; // 设置轮播容器高度
  margin-top: 30px;
}

.layout-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;

  .switch-control {
    :deep(.el-switch__label) {
      color: #666;
    }
  }
}
.partner-grid-container .partner-grid{
  grid-template-columns: repeat(3, 1fr);
  
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}
.partner-grid-container{
 height: calc(100vh - 400px);
}

// 大图显示样式
.big-image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; //确保在最上层
  cursor: pointer;
}

.enlarged-image {
  padding: 50px;
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  cursor: default; // 图片本身不响应关闭事件，除非事件冒泡
  border-radius: 8px; // 可选：为大图添加圆角
  box-shadow: 0 10px 30px rgba(0,0,0,0.3); // 可选：为大图添加阴影
}
</style> 